import { render, staticRenderFns } from "./rootApp.vue?vue&type=template&id=cae2a4a8&"
import script from "./rootApp.vue?vue&type=script&lang=js&"
export * from "./rootApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports